import { createFileRoute } from "@tanstack/react-router";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { OvertimeApprovalInbox } from "@/components/supervisor/overtime/OvertimeApprovalInbox";
import PageHeader from "@/components/reusable-components/header/page-header";
import { requireFeature } from "@/lib/feature-gate";

export const Route = createFileRoute("/supervisor/_layout/overtime-approvals")({
  beforeLoad: () => {
    // Not gated on overtime_approval_required: the backend lists and decides
    // these claims either way, and claims still route here with it off (T-165).
    requireFeature("attendance");
  },
  component: OvertimeApprovalsPage,
});

function OvertimeApprovalsPage() {
  return (
    <SidebarInset>
      <DashboardHeader />
      <div className="space-y-4 p-6 pt-0">
        <PageHeader
          title="Overtime Approvals"
          description="Overtime requests waiting on your decision. Approve or reject with a note."
        />
        <OvertimeApprovalInbox />
      </div>
    </SidebarInset>
  );
}
